module.exports = __webpack_public_path__ + "static/media/success-mb-en.b7c89f1e.png";